import { setItem, getItem } from 'owa-local-storage';

const LogicalRingKey = 'LogicalRing';
export type LogicalRing = 'Dogfood' | 'Microsoft' | 'FirstRelease' | 'WW' | 'Unknown';

let logicalRing: LogicalRing | null;
export function setLogicalRing(ring: LogicalRing) {
    logicalRing = ring;
    setItem(window, LogicalRingKey, ring);
}

export function getLogicalRing() {
    if (!logicalRing) {
        logicalRing = getItem(window, LogicalRingKey) as (LogicalRing | null);
    }

    return logicalRing;
}
